import { getListLanguage } from './getData'

const languages = {
  namespaced: true,
  state: {
    listLanguages: [],
    idSelected: '',
    langId: () => localStorage.getItem('langId') || localStorage.getItem('defaultLangId') || '5bd9f3ee7fa5610014fed21e',
    defaultLangId: localStorage.getItem('defaultLangId') || '5bd9f3ee7fa5610014fed21e',
    listSelectLanguage: []
  },
  actions: {
    setInit: async ({ commit }) => {
      await getListLanguage(commit)
    }
  },
  mutations: {
    updateList: (state, list) => {
      state.listLanguages = list || []
      state.listSelectLanguage = []
      if (list) {
        let activeList = list.filter(item => item.active)
        activeList.forEach(item => {
          state.listSelectLanguage.push(
            { text: item.name,
              value: item._id }
          )
        })
      }
    }
  }

}

export default languages
